import { render, staticRenderFns } from "./PlanPricing.vue?vue&type=template&id=f48da28a&scoped=true"
import script from "./PlanPricing.vue?vue&type=script&lang=js"
export * from "./PlanPricing.vue?vue&type=script&lang=js"
import style0 from "./PlanPricing.vue?vue&type=style&index=0&id=f48da28a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48da28a",
  null
  
)

export default component.exports